import { render, staticRenderFns } from "./frlclfcxcxb.vue?vue&type=template&id=b534ff70&scoped=true&"
import script from "./frlclfcxcxb.vue?vue&type=script&lang=js&"
export * from "./frlclfcxcxb.vue?vue&type=script&lang=js&"
import style0 from "./frlclfcxcxb.vue?vue&type=style&index=0&id=b534ff70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b534ff70",
  null
  
)

export default component.exports